<kendo-window [top]="top" [left]="left" [width]="330" [resizable]="false" class="leaflet-box-shadow" [style.visibility]="display() ? 'visible' : 'hidden'">
  <kendo-window-titlebar>
    <span class="k-window-title">
      {{textConfig.title}}
    </span>
    <button kendoWindowCloseAction *ngIf="!measuring()" (click)="handleClose()"></button>
  </kendo-window-titlebar>

  <form [id]="formId" [formGroup]="form" (ngSubmit)="handleSubmit()">
    <div class="row align-items-end">
      <div class="col-6">
        <div class="d-flex flex-column">
          <label class="input-label">{{textConfig.referenceLengthLabel}}</label>
          <qpoint-reactive-form-input-group>
            <kendo-numerictextbox formControlName="referenceLength" [decimals]="0" [readonly]="true" [spinners]="false" [format]="'# ' + textConfig.referenceLengthUnit"></kendo-numerictextbox>
          </qpoint-reactive-form-input-group>
        </div>
      </div>
      <div class="col-6 d-flex" [style.height.px]="29.5">
        <qpoint-button icon="ruler-horizontal" iconType="regular" [variant]="scaleButtonVariant()" [disabled]="measuring()" class="h-100 d-flex w-100" btnClass="w-100" (buttonClicked)="measureScale()">
          {{textConfig.referenceLengthButton}}
        </qpoint-button>
      </div>
    </div>

    <div class="row mt-2 align-items-end">
      <div class="col-6 d-flex flex-column">
        <label class="input-label">{{textConfig.realLengthLabel}}</label>
        <qpoint-reactive-form-input-group>
          <kendo-numerictextbox [min]="0" [decimals]="2" [spinners]="false" formControlName="realLength" [format]="'##.00 ' + textConfig.realLengthUnit" [placeholder]="textConfig.realLengthUnit">
          </kendo-numerictextbox>
        </qpoint-reactive-form-input-group>
      </div>

      <div class="col-12 mt-3" *ngIf="scaleText() as scaleText">
        <span>{{scaleText}}</span>
      </div>
    </div>
  </form>

  <div class="k-actions k-actions-end px-0 mt-3 d-flex align-items-center justify-content-between">
    <div>
      <qpoint-button *ngIf="form.get('referenceLength').value && form.get('realLength').value"
        [variant]="ButtonVariant.icon" icon="trash-can" iconType="regular" class='trash-button'
        (buttonClicked)="deleteScale()" [disabled]="measuring() || deleteScaleEditMode()">
      </qpoint-button>
    </div>

    <div class="d-flex ms-auto gap-2">
      <qpoint-button variant="secondary" (buttonClicked)="handleCancel()" [disabled]="deleteScaleEditMode()">{{textConfig.cancelButton }}</qpoint-button>
      <qpoint-button variant="primary" type="submit" [formId]="formId" [disabled]="form.invalid || deleteScaleEditMode()">{{textConfig.confirmButton}}</qpoint-button>
    </div>
  </div>
</kendo-window>
